export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-4-05.319f625e.jpg";